import { DateStr, toDateRange } from '@mi-front/core';
import moment from 'moment-timezone';
import { GipReportValues } from '../types';

export function useGipReportDefaultValues(data: Partial<GipReportValues> = {}): GipReportValues {
  const { from, to } = toDateRange(moment().format('YYYY-MM-DD') as DateStr);

  return {
    from,
    to,
    stationsSelectionType: 'advanced',
    stations: [],
    stationsFilter: [],
    advertisers: [],
    campaigns: [],
    versions: [],
    customFieldKey: null,
    customFieldValue: '',
    customIds: [],
    orders: [],
    excludedMatches: [],
    ...data,
  };
}
